import Vue from 'vue'
import Router from 'vue-router'
import { getCookie } from '../utils/cookie'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

let routes = [
  {
    path: '/',
    redirect: '/register'
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../components/login.vue'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: resolve => require(['../components/register.vue'], resolve),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    component: resolve => require(['../components/registerSuccess.vue'], resolve),
    meta: {
      title: '注册成功'
    }
  },
  {
    path: '/resetPwd',
    name: 'resetPwd',
    component: resolve => require(['../components/resetPwd.vue'], resolve),
    meta: {
      title: '重置密码'
    }
  },
  {
    path: '/xgyz',
    name: 'xgyz',
    component: resolve => require(['../pages/xgyz.vue'], resolve),
    meta: {
      title: '小瓜云展'
    }
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: resolve => require(['../pages/myAccount.vue'], resolve),
    meta: {
      title: '账号信息'
    }
    // children: [
    //   {
    //     path: 'real-info',
    //     name: 'real-info',
    //     component: resolve => require(['../pages/realInfo.vue'], resolve),
    //     meta: {
    //       title: '企业实名认证'
    //     }
    //   },
    //   {
    //     path: 'verify',
    //     name: 'verify',
    //     component: resolve => require(['../pages/verify.vue'], resolve),
    //     meta: {
    //       title: '认证通过'
    //     }
    //   }
    // ]
  },
  {
    path: '/my-account/real-info',
    name: 'real-info',
    component: resolve => require(['../pages/realInfo.vue'], resolve),
    meta: {
      title: '企业实名认证'
    }
  },
  {
    path: '/my-account/real-info/verify',
    name: 'verify',
    component: resolve => require(['../pages/verify.vue'], resolve),
    meta: {
      title: '企业实名认证'
    }
  }
]

const router = new Router({
  mode: 'history',
  linkActiveClass: 'router-link-active',
  routes: routes
})

// router.beforeEach((to, from, next) => {
//   const isLogin = getCookie('user') ? 'true' : 'false'
//   if (isLogin == 'false' && to.path !== '/login') {
//     next('/login')
//   }
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js